module.exports = __webpack_public_path__ + "img/q_diamond.fb012eb5.jpg";